const { default: Styled } = require('styled-components');
const { default: FormControl } = require('@mui/material/FormControl');

const internals = {};

module.exports = function SelectFormControl(props) {

    const { StyledFormControl } = internals;

    return (
        <StyledFormControl {...props} />
    );
};

internals.StyledFormControl = Styled(FormControl)`
    width: 100%;
`;
